module.exports = __webpack_public_path__ + "static/media/spiky_dj_tag_1.2434202d.mp3";